import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "Notification/";

const getNotification = async (isArchived) => await axiosInstance.get(ENDPOINTORIGIN + 'GetNotifications?isArchived=' + isArchived, constants.REQUIRE_INTERCEPTORS);

const setNotificationAsRead = async (notificationId) => await axiosInstance.post(ENDPOINTORIGIN + 'SetNotificationAsRead?notificationId=' + notificationId, {}, constants.REQUIRE_INTERCEPTORS);

const deleteNotification = async (notificationId) => await axiosInstance.get(ENDPOINTORIGIN + 'DeleteNotification?notificationId=' + notificationId, constants.REQUIRE_INTERCEPTORS);

const archiveNotification = async (notificationId) => await axiosInstance.get(ENDPOINTORIGIN + 'ArchiveNotification?notificationId=' + notificationId, constants.REQUIRE_INTERCEPTORS);

export {
    getNotification,
    setNotificationAsRead,
    deleteNotification,
    archiveNotification
}